"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mesh_rpc_client_1 = require("@0x/mesh-rpc-client");
var utils_1 = require("@0x/utils");
var order_store_1 = require("../order_store");
var utils_2 = require("../utils");
var base_order_provider_1 = require("./base_order_provider");
var MeshOrderProvider = /** @class */ (function (_super) {
    __extends(MeshOrderProvider, _super);
    /**
     * Instantiates a [Mesh](https://github.com/0xProject/0x-mesh) Order Provider. This provider writes
     * all orders stored in Mesh to the OrderStore and subscribes all Mesh updates.
     * @param opts `MeshOrderProviderOpts` containing the websocketEndpoint and additional Mesh options
     * @param orderStore The `OrderStore` where orders are added and removed from
     */
    function MeshOrderProvider(opts, orderStore) {
        var _this = _super.call(this, orderStore) || this;
        _this._wsClient = new mesh_rpc_client_1.WSClient(opts.websocketEndpoint, opts.wsOpts);
        return _this;
    }
    /**
     * Converts the OrderEvent or OrderInfo from Mesh  into an APIOrder.
     * If the OrderInfo is a RejectedOrderInfo the remainingFillableTakerAssetAmount is
     * assumed to be 0.
     * @param orderEvent The `OrderEvent` from a Mesh subscription update
     */
    MeshOrderProvider._orderInfoToAPIOrder = function (orderEvent) {
        var remainingFillableTakerAssetAmount = orderEvent.fillableTakerAssetAmount
            ? orderEvent.fillableTakerAssetAmount
            : new utils_1.BigNumber(0);
        // TODO(dekz): Remove the any hack when mesh is published v3
        return {
            // tslint:disable:no-unnecessary-type-assertion
            order: orderEvent.signedOrder,
            metaData: {
                orderHash: orderEvent.orderHash,
                remainingFillableTakerAssetAmount: remainingFillableTakerAssetAmount,
            },
        };
    };
    /**
     * Returns the available asset pairs. If no subscription to Mesh exists (and therefore no orders) it is
     * created and awaited on. Once the connection has been initialized the orders in the store are returned
     * as asset pairs.
     */
    MeshOrderProvider.prototype.getAvailableAssetDatasAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, _a, assetPairsItems, minAmount, maxAmount, precision, _b, _c, assetPairKey, _d, assetA, assetB, assetDataA, assetDataB;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0: return [4 /*yield*/, this._initializeIfRequiredAsync()];
                    case 1:
                        _e.sent();
                        assetPairsItems = [];
                        minAmount = new utils_1.BigNumber(0);
                        maxAmount = new utils_1.BigNumber(2).pow(256).minus(1);
                        precision = base_order_provider_1.DEFAULT_TOKEN_PRECISION;
                        try {
                            for (_b = __values(this._orderStore.keys()), _c = _b.next(); !_c.done; _c = _b.next()) {
                                assetPairKey = _c.value;
                                _d = __read(order_store_1.OrderStore.assetPairKeyToAssets(assetPairKey), 2), assetA = _d[0], assetB = _d[1];
                                assetDataA = { assetData: assetA, minAmount: minAmount, maxAmount: maxAmount, precision: precision };
                                assetDataB = { assetData: assetB, minAmount: minAmount, maxAmount: maxAmount, precision: precision };
                                assetPairsItems.push({ assetDataA: assetDataA, assetDataB: assetDataB });
                                assetPairsItems.push({ assetDataA: assetDataB, assetDataB: assetDataA });
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [2 /*return*/, assetPairsItems];
                }
            });
        });
    };
    /**
     * Creates a subscription for all asset pairs in Mesh.
     * @param makerAssetData the Maker Asset Data
     * @param takerAssetData the Taker Asset Data
     */
    MeshOrderProvider.prototype.createSubscriptionForAssetPairAsync = function (_makerAssetData, _takerAssetData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // Create the subscription first to get any updates while waiting for the request
                    return [4 /*yield*/, this._initializeIfRequiredAsync()];
                    case 1:
                        // Create the subscription first to get any updates while waiting for the request
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Submits the SignedOrder to the Mesh node
     * @param orders the set of signed orders to add
     */
    MeshOrderProvider.prototype.addOrdersAsync = function (orders) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accepted, rejected;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, utils_2.utils.attemptAsync(function () { return _this._wsClient.addOrdersAsync(orders); })];
                    case 1:
                        _a = _b.sent(), accepted = _a.accepted, rejected = _a.rejected;
                        // TODO(dekz): Remove the any hack when mesh is published v3
                        return [2 /*return*/, {
                                accepted: accepted.map(function (o) { return o.signedOrder; }),
                                rejected: rejected.map(function (o) { return ({ order: o.signedOrder, message: o.status.message }); }),
                            }];
                }
            });
        });
    };
    /**
     * Destroys the order provider, removing any subscriptions
     */
    MeshOrderProvider.prototype.destroyAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._wsClient.destroy();
                return [2 /*return*/];
            });
        });
    };
    /**
     * Creates the order subscription unless one already exists. If one does not exist
     * it also handles the reconnection logic.
     */
    MeshOrderProvider.prototype._initializeIfRequiredAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this._wsSubscriptionId) {
                            return [2 /*return*/];
                        }
                        _a = this;
                        return [4 /*yield*/, this._wsClient.subscribeToOrdersAsync(this._handleOrderUpdatesAsync.bind(this))];
                    case 1:
                        _a._wsSubscriptionId = _b.sent();
                        return [4 /*yield*/, this._fetchOrdersAndStoreAsync()];
                    case 2:
                        _b.sent();
                        // On Reconnnect sync all of the orders currently stored
                        this._wsClient.onReconnected(function () {
                            void _this._syncOrdersInOrderStoreAsync();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Syncs the orders currently stored in the OrderStore. This is used when the connection to mesh
     * has reconnected. During this outage there are missed OrderEvents so all orders are re-validated
     * for every known asset pair.
     */
    MeshOrderProvider.prototype._syncOrdersInOrderStoreAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_2, _a, _loop_1, this_1, _b, _c, assetPairKey, e_2_1;
            var _this = this;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _loop_1 = function (assetPairKey) {
                            var currentOrders, rejected;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        currentOrders = this_1._orderStore.getOrderSetForAssetPair(assetPairKey);
                                        return [4 /*yield*/, utils_2.utils.attemptAsync(function () {
                                                return _this._wsClient.addOrdersAsync(Array.from(currentOrders.values()).map(function (o) { return o.order; }));
                                            })];
                                    case 1:
                                        rejected = (_a.sent()).rejected;
                                        // Remove any rejected orders
                                        return [4 /*yield*/, this_1._updateStoreAsync({
                                                assetPairKey: assetPairKey,
                                                added: [],
                                                removed: rejected.map(function (o) { return MeshOrderProvider._orderInfoToAPIOrder(o); }),
                                            })];
                                    case 2:
                                        // Remove any rejected orders
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _b = __values(this._orderStore.keys()), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        assetPairKey = _c.value;
                        return [5 /*yield**/, _loop_1(assetPairKey)];
                    case 3:
                        _d.sent();
                        _d.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_2_1 = _d.sent();
                        e_2 = { error: e_2_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_2) throw e_2.error; }
                        return [7 /*endfinally*/];
                    case 8: return [4 /*yield*/, this._fetchOrdersAndStoreAsync()];
                    case 9:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Fetches all of the Orders available in Mesh. All orders are then stored in the
     * OrderStore.
     */
    MeshOrderProvider.prototype._fetchOrdersAndStoreAsync = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_3, _a, e_4, _b, ordersByAssetPairKey, orders, orders_1, orders_1_1, order, _c, makerAssetData, takerAssetData, assetPairKey, _d, _e, assetPairKey, e_4_1;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        ordersByAssetPairKey = {};
                        return [4 /*yield*/, utils_2.utils.attemptAsync(function () { return _this._wsClient.getOrdersAsync(); })];
                    case 1:
                        orders = _f.sent();
                        try {
                            for (orders_1 = __values(orders), orders_1_1 = orders_1.next(); !orders_1_1.done; orders_1_1 = orders_1.next()) {
                                order = orders_1_1.value;
                                _c = order.signedOrder, makerAssetData = _c.makerAssetData, takerAssetData = _c.takerAssetData;
                                assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                                if (!ordersByAssetPairKey[assetPairKey]) {
                                    ordersByAssetPairKey[assetPairKey] = [];
                                }
                                ordersByAssetPairKey[assetPairKey].push(MeshOrderProvider._orderInfoToAPIOrder(order));
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (orders_1_1 && !orders_1_1.done && (_a = orders_1.return)) _a.call(orders_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        _f.label = 2;
                    case 2:
                        _f.trys.push([2, 7, 8, 9]);
                        _d = __values(Object.keys(ordersByAssetPairKey)), _e = _d.next();
                        _f.label = 3;
                    case 3:
                        if (!!_e.done) return [3 /*break*/, 6];
                        assetPairKey = _e.value;
                        return [4 /*yield*/, this._updateStoreAsync({
                                added: ordersByAssetPairKey[assetPairKey],
                                removed: [],
                                assetPairKey: assetPairKey,
                            })];
                    case 4:
                        _f.sent();
                        _f.label = 5;
                    case 5:
                        _e = _d.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_4_1 = _f.sent();
                        e_4 = { error: e_4_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                        }
                        finally { if (e_4) throw e_4.error; }
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Handles the order events converting to APIOrders and either adding or removing based on its kind.
     * @param orderEvents The set of `OrderEvents` returned from a mesh subscription update
     */
    MeshOrderProvider.prototype._handleOrderUpdatesAsync = function (orderEvents) {
        return __awaiter(this, void 0, void 0, function () {
            var e_5, _a, e_6, _b, addedRemovedByAssetPairKey, orderEvents_1, orderEvents_1_1, event_1, _c, makerAssetData, takerAssetData, assetPairKey, apiOrder, _d, _e, assetPairKey, e_6_1;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        addedRemovedByAssetPairKey = {};
                        try {
                            for (orderEvents_1 = __values(orderEvents), orderEvents_1_1 = orderEvents_1.next(); !orderEvents_1_1.done; orderEvents_1_1 = orderEvents_1.next()) {
                                event_1 = orderEvents_1_1.value;
                                _c = event_1.signedOrder, makerAssetData = _c.makerAssetData, takerAssetData = _c.takerAssetData;
                                assetPairKey = order_store_1.OrderStore.getKeyForAssetPair(makerAssetData, takerAssetData);
                                if (!addedRemovedByAssetPairKey[assetPairKey]) {
                                    addedRemovedByAssetPairKey[assetPairKey] = { added: [], removed: [], assetPairKey: assetPairKey };
                                }
                                apiOrder = MeshOrderProvider._orderInfoToAPIOrder(event_1);
                                switch (event_1.endState) {
                                    case mesh_rpc_client_1.OrderEventEndState.Added:
                                    case mesh_rpc_client_1.OrderEventEndState.Unexpired: {
                                        addedRemovedByAssetPairKey[assetPairKey].added.push(apiOrder);
                                        break;
                                    }
                                    case mesh_rpc_client_1.OrderEventEndState.Cancelled:
                                    case mesh_rpc_client_1.OrderEventEndState.Expired:
                                    case mesh_rpc_client_1.OrderEventEndState.FullyFilled:
                                    case mesh_rpc_client_1.OrderEventEndState.Unfunded:
                                    case mesh_rpc_client_1.OrderEventEndState.StoppedWatching: {
                                        addedRemovedByAssetPairKey[assetPairKey].removed.push(apiOrder);
                                        break;
                                    }
                                    case mesh_rpc_client_1.OrderEventEndState.FillabilityIncreased:
                                    case mesh_rpc_client_1.OrderEventEndState.Filled: {
                                        addedRemovedByAssetPairKey[assetPairKey].added.push(apiOrder);
                                        break;
                                    }
                                    default:
                                        break;
                                }
                            }
                        }
                        catch (e_5_1) { e_5 = { error: e_5_1 }; }
                        finally {
                            try {
                                if (orderEvents_1_1 && !orderEvents_1_1.done && (_a = orderEvents_1.return)) _a.call(orderEvents_1);
                            }
                            finally { if (e_5) throw e_5.error; }
                        }
                        _f.label = 1;
                    case 1:
                        _f.trys.push([1, 6, 7, 8]);
                        _d = __values(Object.keys(addedRemovedByAssetPairKey)), _e = _d.next();
                        _f.label = 2;
                    case 2:
                        if (!!_e.done) return [3 /*break*/, 5];
                        assetPairKey = _e.value;
                        return [4 /*yield*/, this._updateStoreAsync(addedRemovedByAssetPairKey[assetPairKey])];
                    case 3:
                        _f.sent();
                        _f.label = 4;
                    case 4:
                        _e = _d.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_6_1 = _f.sent();
                        e_6 = { error: e_6_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
                        }
                        finally { if (e_6) throw e_6.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return MeshOrderProvider;
}(base_order_provider_1.BaseOrderProvider));
exports.MeshOrderProvider = MeshOrderProvider;
//# sourceMappingURL=mesh_order_provider.js.map